import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import { Service } from '../../types/services';
import AcademiaButton from '../CommonComps/Buttons/AcademiaButton';
import ChangeServicePopularityModal from '../CommonComps/Modals/ChangeServicePopularityModal';
import CreateEditServiceModal from '../CommonComps/Modals/CreateEditServiceModal';

const CreateServiceAction = ({
  serviceList,
  hasCreatePermission,
  hasUpdatePermission,
}: {
  serviceList: Array<Service>;
  hasCreatePermission: boolean;
  hasUpdatePermission: boolean;
}) => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showPopularityModal, setShowPopularityModal] =
    useState<boolean>(false);

  const popularServiceCount = serviceList.reduce(
    (count, service) => (service.is_most_popular ? (count += 1) : count),
    0
  );

  // rendering create service action component here
  return (
    <div className='flex w-full flex-col md:flex-row items-center justify-center xl:justify-end gap-3 md:gap-5'>
      {popularServiceCount > 1 ? (
        <AcademiaButton
          title={
            !hasUpdatePermission ? 'You do not have permissions!' : undefined
          }
          type='button'
          onClick={() => setShowPopularityModal(true)}
          variant='premium'
          icon={<TbSquareRoundedPlusFilled className='size-6' />}
          additionalClassNames='w-full xl:w-fit'
          isDisabled={!hasUpdatePermission}
        >
          Change Popularity
        </AcademiaButton>
      ) : null}

      <AcademiaButton
        title={
          !hasCreatePermission ? 'You do not have permissions!' : undefined
        }
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
        additionalClassNames='w-full xl:w-fit'
        isDisabled={!hasCreatePermission}
      >
        Create Service
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditServiceModal
            title='create'
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showPopularityModal && (
          <ChangeServicePopularityModal
            handleModalClose={() => setShowPopularityModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateServiceAction;
